const Wommen_State_Options = [
  { name: '无', key: 'None'},
  { name: '备孕', key: 'PregnancyPreparation'},
  { name: '孕期', key: 'Pregnancy'},
  { name: '产后（哺乳）', key: 'Lactation'},
  { name: '产后（不哺乳）', key: 'NonLactation'},
  { name: '产后（混合哺乳）', key: 'MixedLactation'},
  { name: '绝经期', key: 'Menopause'}
]

const Fetus_Type = [
  { name: '单胎', key: 'Single'},
  { name: '双胎', key: 'Double'}
]

const Childbirth_Type = [
  { name: '顺产', key: 'Natural'},
  { name: '剖宫产', key: 'Caesarean'}
]

export {
  Childbirth_Type,
  Wommen_State_Options,
  Fetus_Type
}